/*@ngInject*/
const CollaborationMediator = function (collaborationRepository, collaborationNoteRepository,
                                                       collaborationLoadTaskRepository,
                                                       collaborationCreateTaskRepository,
                                                       collaborationUpdateTaskRepository,
                                                       collaborationDeleteTaskRepository,
                                                       collaborationNotifyTaskRepository,
                                                       loadSubmissionAttachmentsRepository,
                                                       collaborationEmailRepository,
                                                       deleteCollaborationNoteRepository,
                                                       updateCollaborationNoteRepository,
                                                       createCollaborationNoteRepository,
                                                       deleteCollaborationEmailRepository,
                                                       forwardCollaborationEmailRepository,
                                                       replyAllCollaborationEmailRepository,
                                                       replyCollaborationEmailRepository,
                                                       sendCollaborationEmailRepository,
                                                       updateCollaborationEmailRepository,
                                                       uploadAttachmentCollaborationEmailRepository,
                                                       createCorrespondenceFormRepository,
                                                       createCorrespondenceEmailRepository,
                                                       hideSharedCollaborationRepository,
                                                       chatMessageListRepository,
                                                       sendChatMessageRepository,
                                                       publishChatMessageRepository,
                                                       unpublishChatMessageRepository,
                                                       inviteChatRepository) {

    this.loadCollaborationItems = function (submissionId, searchInput) {
        return collaborationRepository.loadCollaborationItems(submissionId, searchInput);
    };

    this.loadCollaborationNote = function (noteId) {
        return collaborationNoteRepository.loadCollaborationNote(noteId);
    };

    this.refreshCollaborationAttachments = function (submissionId) {
        return collaborationRepository.refreshCollaborationAttachments(submissionId);
    };

    this.createCollaborationNote = function (data) {
        return createCollaborationNoteRepository.createCollaborationNote(data);
    };

    this.updateCollaborationNote = function (noteId, data) {
        return updateCollaborationNoteRepository.updateCollaborationNote(noteId, data);
    };

    this.deleteCollaborationNote = function (noteId) {
        return deleteCollaborationNoteRepository.deleteCollaborationNote(noteId);
    };

    this.loadCollaborationTask = function (taskId) {
        return collaborationLoadTaskRepository.loadCollaborationTask(taskId);
    };

    this.createCollaborationTask = function (data) {
        return collaborationCreateTaskRepository.createCollaborationTask(data);
    };

    this.updateCollaborationTask = function (taskId, data) {
        return collaborationUpdateTaskRepository.updateCollaborationTask(taskId, data);
    };

    this.updateCollaborationTaskAttachment = function (taskId, data) {
        return collaborationUpdateTaskRepository.updateCollaborationTaskAttachment(taskId, data);
    };

    this.deleteCollaborationTaskAttachment = function (taskId, attachmentId) {
        return collaborationDeleteTaskRepository.deleteCollaborationTaskAttachment(taskId, attachmentId);
    };

    this.deleteCollaborationTask = function (taskId) {
        return collaborationDeleteTaskRepository.deleteCollaborationTask(taskId);
    };

    this.notifyTaskAssignee = function (taskId) {
        return collaborationNotifyTaskRepository.notifyTaskAssignee(taskId);
    };

    this.loadSubmissionAttachments = function (submissionId) {
        return loadSubmissionAttachmentsRepository.loadSubmissionAttachments(submissionId);
    };

    this.loadSharedSubmissionAttachments = function (submissionId) {
        return loadSubmissionAttachmentsRepository.loadSharedSubmissionAttachments(submissionId);
    };

    this.loadCollaborationEmail = function (emailId) {
        return collaborationEmailRepository.loadCollaborationEmail(emailId);
    };

    this.createCollaborationEmail = function () {
        return collaborationEmailRepository.createCollaborationEmail();
    };

    this.updateCollaborationEmail = function (email) {
        return updateCollaborationEmailRepository.updateCollaborationEmail(email);
    };

    this.deleteCollaborationEmail = function (emailId) {
        return deleteCollaborationEmailRepository.deleteCollaborationEmail(emailId);
    };

    this.sendCollaborationEmail = function (email) {
        return sendCollaborationEmailRepository.sendCollaborationEmail(email);
    };

    this.forwardEmail = function (emailId) {
        return forwardCollaborationEmailRepository.forward(emailId);
    };

    this.replyEmail = function (emailId) {
        return replyCollaborationEmailRepository.reply(emailId);
    };

    this.replyAllEmail = function (emailId) {
        return replyAllCollaborationEmailRepository.replyAll(emailId);
    };

    this.uploadAttachmentEmail = function (emailId, data, file) {
        return uploadAttachmentCollaborationEmailRepository.uploadAttachment(emailId, data, file);
    };

    this.createEmailCorrespondenceForm = function (submissionId) {
        return createCorrespondenceFormRepository.createEmailCorrespondenceForm(submissionId);
    };

    this.createCorrespondenceForm = function (submissionId) {
        return createCorrespondenceFormRepository.createCorrespondenceForm(submissionId);
    };

    this.generateLetter = function (submissionId, formId)  {
        return createCorrespondenceFormRepository.generateLetter(submissionId, formId);
    };

    this.createCorrespondenceEmail = function (submissionId) {
        return createCorrespondenceEmailRepository.createCorrespondenceEmail(submissionId);
    };

    this.hideAllSharedCollaborationItem = function (submissionId) {
        return hideSharedCollaborationRepository.hideSharedCollaboration(submissionId);
    };

    this.getChatMessageList = function(submissionId) {
        return chatMessageListRepository.getChatMessageList(submissionId);
    };

    this.sendChatMessage = function(submissionId, chatMessage) {
        return sendChatMessageRepository.sendChatMessage(submissionId, chatMessage);
    };

    this.publishChatMessage = function(chatMessageId) {
        return publishChatMessageRepository.publishChatMessage(chatMessageId);
    };

    this.unpublishChatMessage = function(chatMessageId) {
        return unpublishChatMessageRepository.unpublishChatMessage(chatMessageId);
    };

    this.sendChatInvitation = function(submissionId, userIds, message) {
        return inviteChatRepository.sendChatInvitation(submissionId, userIds, message);
    };
};

angular.module('gw-um-submission')
    .service('collaborationMediator', CollaborationMediator);
